import {Component, ContentChildren, forwardRef, QueryList} from '@angular/core';
import {ExerciseComponent} from 'app/content/screen/exercise/exercise.component';
import {
    AssignmentGapChoiceOptionComponent,
    AssignmentGapChoiceOptionInterface,
} from 'app/content/screen/components/assignment-gap-choice/assignment-gap-choice-option/assignment-gap-choice-option.component';

@Component({
    selector: 'assignment-gap-choice',
    templateUrl: './assignment-gap-choice.component.html',
    styleUrls: ['./assignment-gap-choice.component.scss'],
    providers: [
        {
            provide: ExerciseComponent,
            useExisting: forwardRef(() => AssignmentGapChoiceComponent),
        },
    ],
})
export class AssignmentGapChoiceComponent extends ExerciseComponent {
    @ContentChildren(AssignmentGapChoiceOptionComponent, {descendants: true})
    private options!: QueryList<AssignmentGapChoiceOptionInterface>;

    public check(): boolean {
        let allOk = true;

        this.options.forEach(option => {
            if (!option.checkAnswerState()) {
                allOk = false;
            }
        });

        return allOk;
    }

    public solve(): void {
        this.options.forEach(option => {
            option.checkAnswers();
        });
    }

    public reset(): void {
        this.options.forEach(option => {
            option.reset();
        });
    }

    public hasAnswer(): boolean {
        return this.options.some(option => option.isChecked());
    }

    public hasWrong(): boolean {
        return this.options.some(option => option.isWrong());
    }

    public retry(): void {
        this.options.forEach(option => {
            if (option.isWrong()) {
                option.reset();
            }
        });
    }
}
